export const rcc_shortcuts = {

  en: {
    translation: {
      Menu: {
        rcc_titre_princ: 'OpenSankey Application Shortcuts',
        rcc_titre_select: 'With the mouse in selection mode',
        rcc_cn_bold: 'Click (element)',
        rcc_cn: 'Select the clicked element and open its configuration',
        rcc_ctrl_cn_bold: 'CTRL + Click (element) / CMD + Click on Mac',
        rcc_ctrl_cn: 'Add or remove the clicked element from the selection',
        rcc_cs_bold: 'Click (drawing area)',
        rcc_cs: 'Deselects all selected elements',
        rcc_click_and_drag_bold: 'Click & drag (drawing area)',
        rcc_click_and_drag: 'Create a selection zone that selects elements included inside',
        rcc_dn_bold: 'Drag (nodes)',
        rcc_dn: 'Move the selected nodes (all selected nodes move together)',
        rcc_shift_dn_bold: 'Shift + Drag (nodes)',
        rcc_shift_dn: 'Lock the movement to a single axis (horizontal or vertical), chosen from the initial motion — release Shift to resume free movement',
        rcc_cdn_bold: 'Right click (element, drawing area)',
        rcc_cdn: 'Open a contextual menu to apply quick changes or open some modals',
        rcc_ad_bold: 'Alt + Drag (labels, values, icons)',
        rcc_ad: 'Repositions the label, value or icon of any element (node, link, free label)',
        rcc_handle_bold: 'Drag (link handles)',
        rcc_handle: 'Adjusts the shape of the link (starting/ending curve, tangents, recycling middle point)',
        rcc_shift_hover_bold: 'Shift + Hover (element)',
        rcc_shift_hover: 'Displays a tooltip for the element',
        rcc_titre_edi: 'With the mouse in edit mode',
        rcc_e_cn_bold: 'Click (drawing area)',
        rcc_e_cn: 'Adds a node where clicked',
        rcc_e_ds_bold: 'Drag (from drawing area)',
        rcc_e_ds: 'Creates a node at the drag start point and then creates a link from the node created to: either a node already existing if you drop on it, or a node that you create at the place where you drop on the drawing area',
        rcc_e_dn_bold: 'Drag (from a node)',
        rcc_e_dn: 'Create a link from the drag start node: either a node already existing if you drop on it, or a node that you create where you drop on the drawing area',
        rcc_titre_toolbar: 'Toolbar',
        rcc_tb_select_bold: 'Selection mode',
        rcc_tb_select: 'Move and select elements',
        rcc_tb_edition_bold: 'Edition mode',
        rcc_tb_edition: 'Create nodes and links by clicking or dragging',
        rcc_tb_style_bold: 'Style paint',
        rcc_tb_style: 'Apply the style of the selected element to others by clicking on them',
        rcc_tb_param_bold: 'Parametric / Absolute',
        rcc_tb_param: 'Switch between parametric (hierarchical) and absolute positioning for nodes',
        rcc_tb_fit_bold: 'Auto-fit',
        rcc_tb_fit: 'Auto-fit the drawing area horizontally or vertically',
        rcc_tb_fullscreen_bold: 'Fullscreen',
        rcc_tb_fullscreen: 'Toggle fullscreen mode',
        rcc_titre_autre: 'Keyboard shortcuts',
        rcc_a_s_bold: 'Delete / Backspace on Mac',
        rcc_a_s: 'Removes selected elements',
        rcc_a_fc_bold: 'Keyboard arrows',
        rcc_a_fc: 'Move the selected nodes according to the mesh',
        rcc_a_dbm_bold: 'Drag (middle mouse button)',
        rcc_a_dbm: 'Pan the drawing area',
        rcc_a_ech_bold: 'Esc',
        rcc_a_ech: 'Closes the menu and resets the mouse mode to selection',
        rcc_titre_OSP: 'Views',
        rcc_osp_cs_bold: 'CTRL+X / CMD+X on Mac',
        rcc_osp_cs: 'Creates a view which can then be modified. To keep the modifications applied to the view, save it with Ctrl+S (CMD+S on Mac).',
        rcc_F7_bold: 'F7 (Fn+F7 on Mac)',
        rcc_F7: 'Switch to master data',
        rcc_F8_bold: 'F8 (Fn+F8 on Mac)',
        rcc_F8: 'Switch to previous view',
        rcc_F9_bold: 'F9 (Fn+F9 on Mac)',
        rcc_F9: 'Switch to next view',
        rcc_ctrl_a_bold: 'CTRL+A / CMD+A on Mac',
        rcc_ctrl_a: 'Select all visible elements',
        rcc_ctrl_c_bold: 'CTRL+C / CMD+C on Mac',
        rcc_ctrl_c: 'Copy selected nodes',
        rcc_ctrl_v_bold: 'CTRL+V / CMD+V on Mac',
        rcc_ctrl_v: 'Paste copied nodes',
        rcc_ctrl_s_bold: 'CTRL+S / CMD+S on Mac',
        rcc_ctrl_s: 'Save to cache',
        rcc_ctrl_shift_s_bold: 'CTRL+SHIFT+S / CMD+SHIFT+S on Mac',
        rcc_ctrl_shift_s: 'Download as JSON',
        rcc_ctrl_alt_s_bold: 'CTRL+ALT+S / CMD+ALT+S on Mac',
        rcc_ctrl_alt_s: 'Download as Excel',
        rcc_ctrl_scrll_bold: 'CTRL+scroll / CMD+scroll on Mac',
        rcc_ctrl_scrll: 'Zoom/Unzoom in the drawing area',
        rcc_ctrl_z_bold: 'CTRL+Z / CMD+Z on Mac',
        rcc_ctrl_z: 'Undo last modification',
        rcc_ctrl_y_bold: 'CTRL+Y / CMD+Y on Mac',
        rcc_ctrl_y: 'Redo canceled modification'
      }
    }
  },
  fr: {
    translation: {
      Menu: {
        rcc_titre_princ: 'Navigation',
        rcc_titre_select: 'Avec la souris en mode sélection',
        rcc_cn_bold: 'Click (élément)',
        rcc_cn: 'Sélectionne l\'élément cliqué et ouvre sa configuration',
        rcc_ctrl_cn_bold: 'CTRL + Click (élément) / CMD + Click sur Mac',
        rcc_ctrl_cn: 'Ajoute ou retire l\'élément cliqué de la sélection',
        rcc_cs_bold: 'Click (zone de dessin)',
        rcc_cs: 'Désélectionne tous les éléments sélectionnés',
        rcc_click_and_drag_bold: 'Click & drag (zone de dessin)',
        rcc_click_and_drag: 'Crée une zone de sélection qui sélectionne les éléments compris à l\'intérieur une fois qu\'on relâche la souris',
        rcc_dn_bold: 'Drag (noeuds)',
        rcc_dn: 'Déplace les noeuds sélectionnés (tous les noeuds sélectionnés se déplacent ensemble)',
        rcc_shift_dn_bold: 'Shift + Drag (noeuds)',
        rcc_shift_dn: 'Verrouille le déplacement sur un seul axe (horizontal ou vertical), choisi selon le mouvement initial — relâcher Shift pour reprendre un déplacement libre',
        rcc_cdn_bold: 'Click droit (élément, zone de dessin)',
        rcc_cdn: 'Ouvre un menu contextuel permettant de faire des modifications rapides ou d\'ouvrir des modales',
        rcc_ad_bold: 'Alt + Drag (labels, valeurs, icônes)',
        rcc_ad: 'Repositionne le label, la valeur ou l\'icône de n\'importe quel élément (noeud, flux, zone de texte)',
        rcc_handle_bold: 'Drag (poignées de flux)',
        rcc_handle: 'Ajuste la forme du flux (courbure début/fin, tangentes, point milieu de recyclage)',
        rcc_shift_hover_bold: 'Shift + Survol (élément)',
        rcc_shift_hover: 'Affiche une infobulle pour l\'élément',
        rcc_titre_edi: 'Avec la souris en mode édition',
        rcc_e_cn_bold: 'Click (zone de dessin)',
        rcc_e_cn: 'Ajoute un noeud à l\'endroit cliqué',
        rcc_e_ds_bold: 'Drag (à partir de la zone de dessin)',
        rcc_e_ds: 'Crée un noeud au point de départ du drag puis crée un flux à partir du noeud crée vers : soit un noeud déjà existant si l\'on drop dessus, soit un noeud que l\'on crée à l\'endroit où l\'on drop sur la zone de dessin',
        rcc_e_dn_bold: 'Drag (à partir d\'un noeud)',
        rcc_e_dn: 'Créer un flux à partir du noeud de départ du drag vers : soit un noeud déjà existant si l\'on drop dessus, soit un noeud que l\'on crée à l\'endroit où l\'on drop sur la zone de dessin',
        rcc_titre_toolbar: 'Barre d\'outils',
        rcc_tb_select_bold: 'Mode sélection',
        rcc_tb_select: 'Déplacer et sélectionner les éléments',
        rcc_tb_edition_bold: 'Mode édition',
        rcc_tb_edition: 'Créer des noeuds et des flux en cliquant ou en glissant',
        rcc_tb_style_bold: 'Pinceau de style',
        rcc_tb_style: 'Applique le style de l\'élément sélectionné aux autres en cliquant dessus',
        rcc_tb_param_bold: 'Paramétrique / Absolu',
        rcc_tb_param: 'Bascule entre le positionnement paramétrique (hiérarchique) et absolu des noeuds',
        rcc_tb_fit_bold: 'Auto-ajustement',
        rcc_tb_fit: 'Ajuste automatiquement la zone de dessin horizontalement ou verticalement',
        rcc_tb_fullscreen_bold: 'Plein écran',
        rcc_tb_fullscreen: 'Active ou désactive le mode plein écran',
        rcc_titre_autre: 'Raccourcis clavier',
        rcc_a_s_bold: 'Suppr / Backspace sur Mac',
        rcc_a_s: 'Supprime les éléments sélectionnés',
        rcc_a_fc_bold: 'Flèches du clavier',
        rcc_a_fc: 'Déplace les noeuds sélectionnés en fonction du grillage',
        rcc_a_dbm_bold: 'Drag (bouton du milieu de la souris)',
        rcc_a_dbm: 'Déplace la zone de dessin',
        rcc_a_ech_bold: 'Echap',
        rcc_a_ech: 'Ferme le menu et remet la souris en mode sélection',
        rcc_titre_OSP: 'Vues',
        rcc_osp_cs_bold: 'CTRL+X / CMD+X sur Mac',
        rcc_osp_cs: 'Crée une vue qui peut être ensuite modifiée, pour conserver les modifications il faut l\'enregistrer avec Ctrl+S (CMD+S sur Mac)',
        rcc_F7_bold: 'F7 (Fn+F7 sur Mac)',
        rcc_F7: 'Retourne aux données maîtres',
        rcc_F8_bold: 'F8 (Fn+F8 sur Mac)',
        rcc_F8: 'Passe à la vue précédente',
        rcc_F9_bold: 'F9 (Fn+F9 sur Mac)',
        rcc_F9: 'Passe à la vue suivante',
        rcc_ctrl_a_bold: 'CTRL+A / CMD+A sur Mac',
        rcc_ctrl_a: 'Sélectionne tous les éléments visibles',
        rcc_ctrl_c_bold: 'CTRL+C / CMD+C sur Mac',
        rcc_ctrl_c: 'Copie les noeuds sélectionnés',
        rcc_ctrl_v_bold: 'CTRL+V / CMD+V sur Mac',
        rcc_ctrl_v: 'Colle les noeuds copiés',
        rcc_ctrl_s_bold: 'CTRL+S / CMD+S sur Mac',
        rcc_ctrl_s: 'Sauvegarde en cache',
        rcc_ctrl_shift_s_bold: 'CTRL+SHIFT+S / CMD+SHIFT+S sur Mac',
        rcc_ctrl_shift_s: 'Télécharge en JSON',
        rcc_ctrl_alt_s_bold: 'CTRL+ALT+S / CMD+ALT+S sur Mac',
        rcc_ctrl_alt_s: 'Télécharge en Excel',
        rcc_ctrl_scrll_bold: 'CTRL+scroll / CMD+scroll sur Mac',
        rcc_ctrl_scrll: 'Zoomer/dézoomer sur la zone de dessin',
        rcc_ctrl_z_bold: 'CTRL+Z / CMD+Z sur Mac',
        rcc_ctrl_z: 'Annule la dernière modification',
        rcc_ctrl_y_bold: 'CTRL+Y / CMD+Y sur Mac',
        rcc_ctrl_y: 'Refait la modification précédemment annulée'
      }
    }
  }
}
